import Vimeo from './Types/Vimeo'
import YouTube from './Types/YouTube'

let MediaTypes = {
  Vimeo,
  YouTube,
}

function getMediaTypes(value = '') {
  let result = []
  if (!value) {
    for (const key in MediaTypes) {
      result.push({ ...MediaTypes[key] })
    }
    result.push('Image')
  } else result.push(value)

  return result
}
export { getMediaTypes, MediaTypes }
